import { configureStore } from "@reduxjs/toolkit";
import { storiesApi, bannersApi, geoApi, eventsApi, sessionApi, usersApi, couponsApi } from "./api";

export const store = configureStore({
    reducer: {
        [storiesApi.reducerPath]: storiesApi.reducer,
        [bannersApi.reducerPath]: bannersApi.reducer,
        [geoApi.reducerPath]: geoApi.reducer,
        [eventsApi.reducerPath]: eventsApi.reducer,
        [sessionApi.reducerPath]: sessionApi.reducer,
        [usersApi.reducerPath]: usersApi.reducer,
        [couponsApi.reducerPath]: couponsApi.reducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware()
            .concat(storiesApi.middleware)
            .concat(bannersApi.middleware)
            .concat(geoApi.middleware)
            .concat(eventsApi.middleware)
            .concat(sessionApi.middleware)
            .concat(usersApi.middleware)
            .concat(couponsApi.middleware)
    ,

});
